/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Cies_P1Inputs */

const es_marketplace_seo_galicia_guide_cies_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Cies_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las Islas Cíes, con la playa de Rodas, son el icono de las Rías Baixas. En temporada alta el acceso está regulado, pero reservar una salida en barco con antelación facilita planificar la visita.`)
};

const gl_marketplace_seo_galicia_guide_cies_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Cies_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As Illas Cíes, coa praia de Rodas, son a icona das Rías Baixas. En tempada alta o acceso está regulado, pero reservar unha saída en barco con antelación facilita planificar a visita.`)
};

const en_marketplace_seo_galicia_guide_cies_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Cies_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Cíes islands, with Rodas beach, are the icon of Rías Baixas. In high season access is regulated, but booking a boat trip in advance makes planning easier.`)
};

/**
* | output |
* | --- |
* | "The Cíes islands, with Rodas beach, are the icon of Rías Baixas. In high season access is regulated, but booking a boat trip in advance makes planning easier." |
*
* @param {Marketplace_Seo_Galicia_Guide_Cies_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_cies_p1 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Cies_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Cies_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_cies_p1(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_cies_p1(inputs)
	return es_marketplace_seo_galicia_guide_cies_p1(inputs)
});